import productCard from "../product/product-card";
import Slider from '../slider';

export default (element) => {
  let slider = null; 

  const initSlider = () => { 
    productCard();
    const recommendedSlider = element.querySelector('[data-recommended-slider]');

    if (recommendedSlider) {
      const prevEl = element.querySelector('[data-recommended-prev]');
      const nextEl = element.querySelector('[data-recommended-next]');
      const paginationEl = element.querySelector('[data-recommended-pagination]');

      slider = new Slider({
        el: recommendedSlider,
        options: { 
          slidesPerView: 2,
          keyboard: true,
          spaceBetween: 10,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: { 
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            745: {
              slidesPerView: 4,
              spaceBetween: 10,
            }
          },
        },
      });
    }
    return slider;
  };

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const { url } = productRecommendationsSection.dataset;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initSlider(); 
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  };

  const productRecommendationsSection = element;
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
};
